export const RANKING_DISPLAY_MODES = ['NORMAL', 'COOPERATIVE', 'BOTH', 'HIDDEN', 'SLIDES'] as const

export type RankingDisplayMode = typeof RANKING_DISPLAY_MODES[number]

export const GAME_RANKING_MODES: Record<string, readonly RankingDisplayMode[]> = {
    IH: ['NORMAL', 'HIDDEN'],
    CAI: ['NORMAL', 'HIDDEN'],
    AC: ['NORMAL', 'COOPERATIVE', 'BOTH', 'HIDDEN', 'SLIDES'],
    ACS: ['NORMAL', 'COOPERATIVE', 'BOTH', 'HIDDEN', 'SLIDES'],
}

export const getGameRankingModes = (activityCode: string): readonly RankingDisplayMode[] => {
    return GAME_RANKING_MODES[activityCode] || ['NORMAL', 'HIDDEN']
}

export const isRankingDisplayMode = (mode: unknown): mode is RankingDisplayMode => {
    return typeof mode === 'string' && RANKING_DISPLAY_MODES.includes(mode as RankingDisplayMode)
}
